export var ActivityClosureReason;
(function (ActivityClosureReason) {
    ActivityClosureReason[ActivityClosureReason["OUT_OF_BUSINESS_HOURS"] = 10] = "OUT_OF_BUSINESS_HOURS";
    ActivityClosureReason[ActivityClosureReason["EXCLUDED_SKILL"] = 20] = "EXCLUDED_SKILL";
    ActivityClosureReason[ActivityClosureReason["ALL_AGENTS_OFFLINE"] = 30] = "ALL_AGENTS_OFFLINE";
    ActivityClosureReason[ActivityClosureReason["NO_AVAILABLE_AGENTS_FOR_TRANSFER"] = 40] = "NO_AVAILABLE_AGENTS_FOR_TRANSFER";
    ActivityClosureReason[ActivityClosureReason["NO_AVAILABILITY_DEFINED"] = 50] = "NO_AVAILABILITY_DEFINED";
})(ActivityClosureReason || (ActivityClosureReason = {}));
;
//# sourceMappingURL=activity-closure-reason.enum.js.map